import { render, staticRenderFns } from "./MemberRequestListCard.vue?vue&type=template&id=df1e60fe&scoped=true"
import script from "./MemberRequestListCard.vue?vue&type=script&lang=ts"
export * from "./MemberRequestListCard.vue?vue&type=script&lang=ts"
import style0 from "./MemberRequestListCard.vue?vue&type=style&index=0&id=df1e60fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1e60fe",
  null
  
)

export default component.exports